import { z } from 'zod';
import { richTextSchema } from '../types/common-types';
import { CrmTaskStatus } from './crm-task-dto';

export const crmTaskInputDtoSchema = z.object({
    description: richTextSchema,
    assignedToId: z.string().uuid().min(1),
    dueDate: z.date(),
    status: z.nativeEnum(CrmTaskStatus).nullable(),
    links: z.array(
        z.object({
            modelType: z.string().min(1),
            modelId: z.string().min(1),
            title: z.string().nullable(),
        }),
    ),
});

export type CrmTaskInputDTO = z.infer<typeof crmTaskInputDtoSchema>;
